<template>
  <div>
  </div>
</template>
<script>
export default {
  // url: 'http://192.168.2.154:12500/api', //开发的接口
  url: 'https://wx.izcare.cn/api', //正式
  aliyunOssUrl:'https://dc.izcare.cn/oss/',//阿里云oss
  timeFormatChange(time, type) {
    //自定义时间转换函数
    var date = new Date(time);
    var Str =
      date.getFullYear() +
      type +
      (date.getMonth() + 1) +
      type +
      date.getDate();
    return Str;
  },
  trim(str) {
    return str.replace(/\s|\xA0/g, "");
  },
  getQueryString(name) { //获取url的参数
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  compare(property) { //排序
    return function(a, b) {
      var value1 = a[property];
      var value2 = b[property];
      return value1 - value2;
    }
  },
  timeFormat(time) {
    if (String(time).indexOf('+0800') > -1 && String(time).indexOf('T') > -1 && String(time).indexOf('.') > -1) {
      time = String(time).replace('+0800', '').replace('T', ' ').replace(/-/ig, '/')
      time = String(time).split('.')[0]
    }
    var d = new Date(time);

    var year = d.getFullYear(); //年  
    var month = d.getMonth() + 1; //月  
    var day = d.getDate(); //日  

    var hh = d.getHours(); //时  
    var mm = d.getMinutes(); //分  
    var ss = d.getSeconds(); //秒  

    var clock = year + "-";

    if (month < 10)
      clock += "0";

    clock += month + "-";

    if (day < 10)
      clock += "0";

    clock += day + " ";

    if (hh < 10)
      clock += "0";

    clock += hh + ":";
    if (mm < 10) clock += '0';
    clock += mm + ":";

    if (ss < 10) clock += '0';
    clock += ss;
    return (clock);
  },
  iosInputHandle() {
    // 判断是否是ios
    var ua = navigator.userAgent;
    if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      let flag = false
      let pageBackNormFunc
      document.body.addEventListener('focusin', () => {
        // 软键盘弹起事件
        flag = true
        pageBackNormFunc && clearTimeout(pageBackNormFunc)
      })
      document.body.addEventListener('focusout', () => {
        // 软键盘关闭事件
        if (flag) {
          pageBackNormFunc = setTimeout(function() {
            // 当键盘收起的时候让页面回到原始位置
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
          }, 200)
        }
        flag = false
      })
    }
  },
  //判断是否是微信浏览器
  is_weixin() {
    var ua = window.navigator.userAgent.toLowerCase(); 
    if (ua.match(/MicroMessenger/i) == 'micromessenger') { 
      return true;
    } else { 
      return false;
    };
  }
}

</script>
<style scoped>
</style>
